import { render, staticRenderFns } from "./VitalsDetails.vue?vue&type=template&id=756db482&"
import script from "./VitalsDetails.vue?vue&type=script&lang=js&"
export * from "./VitalsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports